module.exports = {"id":"202061","name":"Jasmin Kurtić","rating":"76","photo":"./data/images/photos/4/202061.png","club":{"name":"Spal","logo":"./data/images/clubs/Spal.png"},"positions":["MC","MOC","ATT"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/JasminKurtic0.json
// module id = 1924
// module chunks = 0